export default __webpack_public_path__ + "static/Stop-the-virus-logo-281c9807d23b4db467dba3e6c0ed99b9.png";